export const environment = {
  apiBaseUrl: 'https://backend-dev.rivlz.com/api/v1',
  landingUrl: 'https://www.rivlz.com',
};
